import React from 'react';
import { createPortal } from 'react-dom';
import './PushNotificationCenterPopup.css';

export default function PushNotificationCenterPopup({ message, onDismiss }) {
  if (!message) return null;

  return createPortal(
    <div
      className="push-notification-overlay"
      role="alertdialog"
      aria-live="polite"
      aria-label="Notification"
      onClick={onDismiss}
    >
      <div
        className="push-notification-card"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="push-notification-close"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          ×
        </button>
        <div className="push-notification-icon" aria-hidden>
          🔔
        </div>
        <p className="push-notification-text">{message}</p>
        <div className="push-notification-progress" aria-hidden>
          <span className="push-notification-progress-bar" />
        </div>
      </div>
    </div>,
    document.body
  );
}
